var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container pab1" },
    [
      _c("div", { staticClass: "row admin-header" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "col-12 col-lg-5" },
          [
            _c("base-input-text", {
              staticClass: "admin-header__search",
              attrs: { icon: "fas fa-search", label: "Szukaj..." },
              model: {
                value: _vm.searchUsers,
                callback: function ($$v) {
                  _vm.searchUsers = $$v
                },
                expression: "searchUsers",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12 col-lg-7" },
          [
            _c(
              "base-button-group",
              { staticClass: "admin-header__views", attrs: { horizontal: "" } },
              [
                _c(
                  "base-button",
                  {
                    staticClass: "admin-header__views-btn",
                    attrs: { btn11: "", pressed: _vm.listParent === "all" },
                    on: {
                      click: function ($event) {
                        return _vm.changeUsersList("all")
                      },
                    },
                  },
                  [_vm._v(" Wszyscy ")]
                ),
                _c(
                  "base-button",
                  {
                    staticClass: "admin-header__views-btn",
                    attrs: { btn11: "", pressed: _vm.listParent === "user" },
                    on: {
                      click: function ($event) {
                        return _vm.changeUsersList("user")
                      },
                    },
                  },
                  [_vm._v(" Uczestnicy ")]
                ),
                _c(
                  "base-button",
                  {
                    staticClass: "admin-header__views-btn",
                    attrs: {
                      btn11: "",
                      pressed: _vm.listParent === "organizer",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.changeUsersList("organizer")
                      },
                    },
                  },
                  [_vm._v(" Organizatorzy ")]
                ),
                _c(
                  "base-button",
                  {
                    staticClass: "admin-header__views-btn",
                    attrs: {
                      btn11: "",
                      pressed: _vm.listParent === "operator",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.changeUsersList("operator")
                      },
                    },
                  },
                  [_vm._v(" Operatorzy ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      !_vm.ready
        ? _c("div", { staticClass: "mat32" }, [_vm._m(1)])
        : _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("base-table", {
                  staticClass: "list",
                  attrs: { headers: _vm.tableHeaders, items: _vm.items },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function ({ sort }) {
                        return [
                          _c(
                            "tr",
                            { staticClass: "list__row" },
                            _vm._l(_vm.tableHeaders, function (header, column) {
                              return _c(
                                "th",
                                {
                                  key: column,
                                  staticClass: "list__row-header",
                                  class: {
                                    "list__row-data--profil":
                                      header.value === "profil",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return sort(column)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(header.text) + " ")]
                              )
                            }),
                            0
                          ),
                        ]
                      },
                    },
                    {
                      key: "body",
                      fn: function ({ displayedItems }) {
                        return _vm._l(displayedItems, function (item) {
                          return _c(
                            "tr",
                            {
                              key: item.id,
                              staticClass:
                                "list__row list__row--pointer list__row--hover",
                              on: {
                                click: function ($event) {
                                  return _vm.modal(item)
                                },
                              },
                            },
                            _vm._l(_vm.tableHeaders, function (header, column) {
                              return _c(
                                "td",
                                {
                                  key: column,
                                  staticClass: "list__row-data",
                                  class: {
                                    "list__row-data--name":
                                      header.value === "fname",
                                    "list__row-data--profil":
                                      header.value === "profil",
                                    "list__row-data--loading": _vm.loading,
                                  },
                                },
                                [
                                  header.value === "profil"
                                    ? _vm._l(
                                        item[header.value],
                                        function (profil, index) {
                                          return _c(
                                            "span",
                                            {
                                              key: item["id"] + "_" + index,
                                              staticClass: "profil-badge",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.profilName(profil))
                                              ),
                                            ]
                                          )
                                        }
                                      )
                                    : [_vm._v(_vm._s(item[header.value]))],
                                ],
                                2
                              )
                            }),
                            0
                          )
                        })
                      },
                    },
                    {
                      key: "no-results",
                      fn: function ({ search: term }) {
                        return [
                          term.length
                            ? _c("div", [
                                _vm._v(" Brak wyników wyszukiwania "),
                                _c("b", [_vm._v(_vm._s(term))]),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
      _vm.ready
        ? _c("div", { staticClass: "row admin__pages" }, [
            _c(
              "div",
              {
                staticClass: "admin__pages-btn",
                class: {
                  "admin__pages-btn--disabled": !_vm.isPreviousPage,
                },
                on: {
                  click: function ($event) {
                    _vm.isPreviousPage ? _vm.prevPage() : ""
                  },
                },
              },
              [
                _vm.isLoadingPrev
                  ? _c("div", { staticClass: "admin__pages-loading" }, [
                      _vm._m(2),
                    ])
                  : _vm._e(),
                _vm._v(" Poprzednie "),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "admin__pages-btn",
                class: { "admin__pages-btn--disabled": !_vm.isNextPage },
                on: {
                  click: function ($event) {
                    _vm.isNextPage ? _vm.nextPage() : ""
                  },
                },
              },
              [
                _vm.isLoadingNext
                  ? _c("div", { staticClass: "admin__pages-loading" }, [
                      _vm._m(3),
                    ])
                  : _vm._e(),
                _vm._v(" Następne "),
              ]
            ),
          ])
        : _vm._e(),
      _c("modal", {
        ref: "userModal",
        staticClass: "modal-hd modal-background",
        on: { "modal-close": _vm.defaultModalData },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [_vm._v(" Edycja konta użytkownika ")]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { staticClass: "userFormWrap" }, [
                  _c("div", { staticClass: "row unset mab24" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("h3", [_vm._v("Dane konta")]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-12 col-lg-2" },
                      [
                        _c("p", { staticClass: "form-input__label" }, [
                          _vm._v("Imię"),
                        ]),
                        _c("base-input-text", {
                          attrs: { error: _vm.errors.firstname },
                          on: {
                            "update:error": function ($event) {
                              return _vm.$set(_vm.errors, "firstname", $event)
                            },
                          },
                          model: {
                            value: _vm.selectedUser.firstname,
                            callback: function ($$v) {
                              _vm.$set(_vm.selectedUser, "firstname", $$v)
                            },
                            expression: "selectedUser.firstname",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-12 col-lg-2" }, [
                      _c(
                        "div",
                        { staticClass: "mal32" },
                        [
                          _c("p", { staticClass: "form-input__label" }, [
                            _vm._v("Nazwisko"),
                          ]),
                          _c("base-input-text", {
                            attrs: { error: _vm.errors.lastname },
                            on: {
                              "update:error": function ($event) {
                                return _vm.$set(_vm.errors, "lastname", $event)
                              },
                            },
                            model: {
                              value: _vm.selectedUser.lastname,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedUser, "lastname", $$v)
                              },
                              expression: "selectedUser.lastname",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-12 col-lg-2" }, [
                      _c(
                        "div",
                        { staticClass: "mal32" },
                        [
                          _c("p", { staticClass: "form-input__label" }, [
                            _vm._v("E-mail"),
                          ]),
                          _c("base-input-text", {
                            attrs: { error: _vm.errors.email },
                            on: {
                              "update:error": function ($event) {
                                return _vm.$set(_vm.errors, "email", $event)
                              },
                            },
                            model: {
                              value: _vm.selectedUser.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedUser, "email", $$v)
                              },
                              expression: "selectedUser.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-12 col-lg-3" }, [
                      _c("div", { staticClass: "mal32" }, [
                        _c("p", { staticClass: "form-input__label" }, [
                          _vm._v("Reset hasła"),
                        ]),
                        _vm.sendingThePassword
                          ? _c(
                              "p",
                              { staticStyle: { "line-height": "40px" } },
                              [_vm._v("Wysyłam hasło")]
                            )
                          : _vm.passwordSent
                          ? _c(
                              "p",
                              { staticStyle: { "line-height": "40px" } },
                              [_vm._v("Link wysłany")]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "btn btn-outline",
                                on: { click: _vm.sendPassword },
                              },
                              [_vm._v("Wyślij link do resetu hasła")]
                            ),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-12 col-lg-2" }, [
                      _c("div", { staticClass: "mal32" }, [
                        _c("p", { staticClass: "form-input__label" }, [
                          _vm._v("Link do hasła"),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "btn btn-outline",
                            class: {
                              "btn--disabled": _vm.generatingPasswordLink,
                            },
                            on: {
                              click: function ($event) {
                                _vm.generatingPasswordLink
                                  ? null
                                  : _vm.sendLinkPassword()
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.generatingPasswordLink
                                    ? "Generuję..."
                                    : "Generuj"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm.linkPassword
                      ? _c("div", { staticClass: "col-12 mat16" }, [
                          _c("p", { staticClass: "form-input__label" }, [
                            _vm._v("Wygenerowany link"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "password-link-row" },
                            [
                              _c("base-input-text", {
                                model: {
                                  value: _vm.linkPassword,
                                  callback: function ($$v) {
                                    _vm.linkPassword = $$v
                                  },
                                  expression: "linkPassword",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "btn btn-outline",
                                  on: { click: _vm.copyPasswordLink },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.linkCopied ? "Skopiowano" : "Kopiuj"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c("hr"),
                  _c("div", { staticClass: "row unset mab24" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mab24" },
                      [
                        _c(
                          "base-input-switch",
                          {
                            attrs: {
                              label: "",
                              icons: "",
                              checked: _vm.selectedUser.userRole,
                            },
                            on: { input: _vm.changeUserRole },
                            model: {
                              value: _vm.selectedUser.userRole,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedUser, "userRole", $$v)
                              },
                              expression: "selectedUser.userRole",
                            },
                          },
                          [_c("h3", [_vm._v("Profil uczestnika")])]
                        ),
                      ],
                      1
                    ),
                    _vm.selectedUser.userRole
                      ? _c(
                          "div",
                          {
                            staticClass: "row unset mab16",
                            staticStyle: { width: "100%" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-12 col-lg-2" },
                              [
                                _c("p", { staticClass: "form-input__label" }, [
                                  _vm._v("Data urodzenia"),
                                ]),
                                _c("base-input-date", {
                                  staticClass: "no-shadow",
                                  attrs: {
                                    initialView: "year",
                                    error: _vm.errors.birthTime,
                                  },
                                  on: {
                                    "update:error": function ($event) {
                                      return _vm.$set(
                                        _vm.errors,
                                        "birthTime",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.selectedUser.birthTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedUser,
                                        "birthTime",
                                        $$v
                                      )
                                    },
                                    expression: "selectedUser.birthTime",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Płeć")]
                                  ),
                                  _c("base-input-radio", {
                                    staticClass: "radio-field__row",
                                    attrs: {
                                      options: [
                                        { value: "M", title: "man" },
                                        { value: "K", title: "woman" },
                                      ],
                                      error: _vm.errors.gender,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.errors,
                                          "gender",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.selectedUser.gender,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser,
                                          "gender",
                                          $$v
                                        )
                                      },
                                      expression: "selectedUser.gender",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Narodowość")]
                                  ),
                                  _c("base-input-select", {
                                    attrs: {
                                      options: _vm.countries,
                                      clearable: false,
                                      label: "Narodowość",
                                      reduce: (country) => country.id,
                                      error: _vm.errors.nationality,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.errors,
                                          "nationality",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.selectedUser.nationality,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser,
                                          "nationality",
                                          $$v
                                        )
                                      },
                                      expression: "selectedUser.nationality",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.selectedUser.userRole
                      ? _c(
                          "div",
                          {
                            staticClass: "row unset",
                            staticStyle: { width: "100%" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-12 col-lg-2" },
                              [
                                _c("p", { staticClass: "form-input__label" }, [
                                  _vm._v("Telefon"),
                                ]),
                                _c("base-input-text", {
                                  attrs: { error: _vm.errors.phone },
                                  on: {
                                    "update:error": function ($event) {
                                      return _vm.$set(
                                        _vm.errors,
                                        "phone",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.selectedUser.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.selectedUser, "phone", $$v)
                                    },
                                    expression: "selectedUser.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Miejscowość")]
                                  ),
                                  _c("base-input-autocomplete", {
                                    staticClass: "user-form__autocomplete",
                                    attrs: {
                                      label: "Miejscowość",
                                      error: _vm.cityError,
                                      "clear-search-on-select": true,
                                      action: "AUTOCOMPLETE_LOCATION",
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        _vm.cityError = $event
                                      },
                                      select: function ($event) {
                                        return _vm.selectCity($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.searchValueCity,
                                      callback: function ($$v) {
                                        _vm.searchValueCity = $$v
                                      },
                                      expression: "searchValueCity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Klub")]
                                  ),
                                  _c("base-input-text", {
                                    model: {
                                      value: _vm.selectedUser.clubname,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser,
                                          "clubname",
                                          $$v
                                        )
                                      },
                                      expression: "selectedUser.clubname",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c("hr"),
                  _c("div", { staticClass: "row mab24" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mab24" },
                      [
                        _c(
                          "base-input-switch",
                          {
                            attrs: {
                              label: "",
                              icons: "",
                              checked: _vm.selectedUser.orgRole,
                              disabled: _vm.selectedUser.opRole,
                            },
                            on: { input: _vm.changeOrgRole },
                            model: {
                              value: _vm.selectedUser.orgRole,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedUser, "orgRole", $$v)
                              },
                              expression: "selectedUser.orgRole",
                            },
                          },
                          [_c("h3", [_vm._v("Profil organizatora")])]
                        ),
                      ],
                      1
                    ),
                    _vm.selectedUser.orgRole
                      ? _c(
                          "div",
                          {
                            staticClass: "row unset mab16",
                            staticStyle: { width: "100%" },
                          },
                          [
                            _c("div", { staticClass: "col-12 mab24" }, [
                              _c("p", { staticClass: "form-input__label" }, [
                                _vm._v("Osobowość prawna organizatora"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "radio-field radio-field__row",
                                  class: {
                                    "input-error-border":
                                      _vm.organizerErrors.legalType,
                                  },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.selectedUser.organizerObj
                                            .legalType,
                                        expression:
                                          "selectedUser.organizerObj.legalType",
                                      },
                                    ],
                                    staticClass: "d-none",
                                    attrs: {
                                      id: "private",
                                      type: "radio",
                                      value: "private",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.selectedUser.organizerObj.legalType,
                                        "private"
                                      ),
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          return _vm.$set(
                                            _vm.selectedUser.organizerObj,
                                            "legalType",
                                            "private"
                                          )
                                        },
                                        function ($event) {
                                          _vm.organizerErrors.legalType = null
                                        },
                                      ],
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "radio-field__label",
                                      attrs: { for: "private" },
                                    },
                                    [_vm._v("Osoba prywatna")]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.selectedUser.organizerObj
                                            .legalType,
                                        expression:
                                          "selectedUser.organizerObj.legalType",
                                      },
                                    ],
                                    staticClass: "d-none",
                                    attrs: {
                                      id: "company",
                                      type: "radio",
                                      value: "company",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.selectedUser.organizerObj.legalType,
                                        "company"
                                      ),
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          return _vm.$set(
                                            _vm.selectedUser.organizerObj,
                                            "legalType",
                                            "company"
                                          )
                                        },
                                        function ($event) {
                                          _vm.organizerErrors.legalType = null
                                        },
                                      ],
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "radio-field__label",
                                      attrs: { for: "company" },
                                    },
                                    [
                                      _vm._v(
                                        "Firma / Fundacja / Stowarzyszenie"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.organizerErrors.legalType
                                ? _c(
                                    "span",
                                    { staticClass: "input-error-alt" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.say[_vm.organizerErrors.legalType]
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-12 col-lg-2" },
                              [
                                _c("p", { staticClass: "form-input__label" }, [
                                  _vm._v("NIP"),
                                ]),
                                _c("base-input-text", {
                                  attrs: { error: _vm.organizerErrors.fvNip },
                                  on: {
                                    "update:error": function ($event) {
                                      return _vm.$set(
                                        _vm.organizerErrors,
                                        "fvNip",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.selectedUser.organizerObj.fvNip,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedUser.organizerObj,
                                        "fvNip",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selectedUser.organizerObj.fvNip",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Nazwa firmy")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: {
                                      error: _vm.organizerErrors.fvFirmname,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.organizerErrors,
                                          "fvFirmname",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.organizerObj
                                          .fvFirmname,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.organizerObj,
                                          "fvFirmname",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.organizerObj.fvFirmname",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Miejscowość")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: {
                                      error: _vm.organizerErrors.fvCity,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.organizerErrors,
                                          "fvCity",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.organizerObj.fvCity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.organizerObj,
                                          "fvCity",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.organizerObj.fvCity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Prowizja od opłaty startowej")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: {
                                      error: _vm.organizerErrors.commision,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.organizerErrors,
                                          "commision",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.organizerObj.commision,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.organizerObj,
                                          "commision",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.organizerObj.commision",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.selectedUser.orgRole
                      ? _c(
                          "div",
                          {
                            staticClass: "row unset mab32",
                            staticStyle: { width: "100%" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-12 col-lg-2" },
                              [
                                _c("p", { staticClass: "form-input__label" }, [
                                  _vm._v("Kod pocztowy"),
                                ]),
                                _c("base-input-text", {
                                  attrs: {
                                    error: _vm.organizerErrors.fvPostcode,
                                  },
                                  on: {
                                    "update:error": function ($event) {
                                      return _vm.$set(
                                        _vm.organizerErrors,
                                        "fvPostcode",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.selectedUser.organizerObj.fvPostcode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedUser.organizerObj,
                                        "fvPostcode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selectedUser.organizerObj.fvPostcode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Ulica")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: {
                                      error: _vm.organizerErrors.fvAddress,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.organizerErrors,
                                          "fvAddress",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.organizerObj.fvAddress,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.organizerObj,
                                          "fvAddress",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.organizerObj.fvAddress",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-min" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Nr domu")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: {
                                      error: _vm.organizerErrors.fvHouseNumber,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.organizerErrors,
                                          "fvHouseNumber",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.organizerObj
                                          .fvHouseNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.organizerObj,
                                          "fvHouseNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.organizerObj.fvHouseNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-min" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Nr lokalu")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: {
                                      error: _vm.organizerErrors.fvFlatNumber,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.organizerErrors,
                                          "fvFlatNumber",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.organizerObj
                                          .fvFlatNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.organizerObj,
                                          "fvFlatNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.organizerObj.fvFlatNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.selectedUser.orgRole
                      ? _c(
                          "div",
                          {
                            staticClass: "row unset",
                            staticStyle: { width: "100%" },
                          },
                          [
                            _c("div", { staticClass: "col-12 mab16" }, [
                              _c("b", [
                                _vm._v(
                                  "Dane organizatora widoczne dla uczestników"
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-12 col-lg-2" },
                              [
                                _c("p", { staticClass: "form-input__label" }, [
                                  _vm._v("Numer telefonu"),
                                ]),
                                _c("base-input-text", {
                                  attrs: { error: _vm.organizerErrors.phone },
                                  on: {
                                    "update:error": function ($event) {
                                      return _vm.$set(
                                        _vm.organizerErrors,
                                        "phone",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.selectedUser.organizerObj.phone,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedUser.organizerObj,
                                        "phone",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selectedUser.organizerObj.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Adres e-mail")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: { error: _vm.organizerErrors.email },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.organizerErrors,
                                          "email",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.organizerObj.email,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.organizerObj,
                                          "email",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.organizerObj.email",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Nazwa organizatora")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: { error: _vm.organizerErrors.name },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.organizerErrors,
                                          "name",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.selectedUser.organizerObj.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.organizerObj,
                                          "name",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.organizerObj.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Przypisz do operatora")]
                                  ),
                                  _c("base-input-select", {
                                    attrs: {
                                      options: _vm.operators,
                                      label: "Operator",
                                      "label-select": "name",
                                      clearable: false,
                                      searchable: true,
                                      reduce: (operator) => operator.id,
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.organizerObj.operator,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.organizerObj,
                                          "operator",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.organizerObj.operator",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c("hr"),
                  _c("div", { staticClass: "row mab24" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mab24" },
                      [
                        _c(
                          "base-input-switch",
                          {
                            attrs: {
                              label: "",
                              icons: "",
                              checked: _vm.selectedUser.opRole,
                              disabled: _vm.selectedUser.orgRole,
                            },
                            on: { input: _vm.changeOpRole },
                            model: {
                              value: _vm.selectedUser.opRole,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedUser, "opRole", $$v)
                              },
                              expression: "selectedUser.opRole",
                            },
                          },
                          [_c("h3", [_vm._v("Profil operatora")])]
                        ),
                      ],
                      1
                    ),
                    _vm.selectedUser.opRole
                      ? _c(
                          "div",
                          {
                            staticClass: "row unset mab16",
                            staticStyle: { width: "100%" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-12 col-lg-2" },
                              [
                                _c("p", { staticClass: "form-input__label" }, [
                                  _vm._v("NIP"),
                                ]),
                                _c("base-input-text", {
                                  attrs: { error: _vm.operatorErrors.fvNip },
                                  on: {
                                    "update:error": function ($event) {
                                      return _vm.$set(
                                        _vm.operatorErrors,
                                        "fvNip",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.selectedUser.operatorObj.fvNip,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedUser.operatorObj,
                                        "fvNip",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selectedUser.operatorObj.fvNip",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Nazwa firmy")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: {
                                      error: _vm.operatorErrors.fvFirmname,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.operatorErrors,
                                          "fvFirmname",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.operatorObj.fvFirmname,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.operatorObj,
                                          "fvFirmname",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.operatorObj.fvFirmname",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Miejscowość")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: { error: _vm.operatorErrors.fvCity },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.operatorErrors,
                                          "fvCity",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.operatorObj.fvCity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.operatorObj,
                                          "fvCity",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.operatorObj.fvCity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Prowizja od zawodów")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: {
                                      error: _vm.operatorErrors.commision,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.operatorErrors,
                                          "commision",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.operatorObj.commision,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.operatorObj,
                                          "commision",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.operatorObj.commision",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.selectedUser.opRole
                      ? _c(
                          "div",
                          {
                            staticClass: "row unset mab32",
                            staticStyle: { width: "100%" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-12 col-lg-2" },
                              [
                                _c("p", { staticClass: "form-input__label" }, [
                                  _vm._v("Kod pocztowy"),
                                ]),
                                _c("base-input-text", {
                                  attrs: {
                                    error: _vm.operatorErrors.fvPostcode,
                                  },
                                  on: {
                                    "update:error": function ($event) {
                                      return _vm.$set(
                                        _vm.operatorErrors,
                                        "fvPostcode",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.selectedUser.operatorObj.fvPostcode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedUser.operatorObj,
                                        "fvPostcode",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selectedUser.operatorObj.fvPostcode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Ulica")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: {
                                      error: _vm.operatorErrors.fvAddress,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.operatorErrors,
                                          "fvAddress",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.operatorObj.fvAddress,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.operatorObj,
                                          "fvAddress",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.operatorObj.fvAddress",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-min" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Nr domu")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: {
                                      error: _vm.operatorErrors.fvHouseNumber,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.operatorErrors,
                                          "fvHouseNumber",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.operatorObj
                                          .fvHouseNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.operatorObj,
                                          "fvHouseNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.operatorObj.fvHouseNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-min" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Nr lokalu")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: {
                                      error: _vm.operatorErrors.fvFlatNumber,
                                    },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.operatorErrors,
                                          "fvFlatNumber",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.selectedUser.operatorObj
                                          .fvFlatNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.operatorObj,
                                          "fvFlatNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.operatorObj.fvFlatNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.selectedUser.opRole
                      ? _c(
                          "div",
                          {
                            staticClass: "row unset",
                            staticStyle: { width: "100%" },
                          },
                          [
                            _c("div", { staticClass: "col-12 mab16" }, [
                              _c("b", [
                                _vm._v(
                                  "Dane operatora widoczne dla uczestników"
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-12 col-lg-2" },
                              [
                                _c("p", { staticClass: "form-input__label" }, [
                                  _vm._v("Numer telefonu"),
                                ]),
                                _c("base-input-text", {
                                  attrs: { error: _vm.operatorErrors.phone },
                                  on: {
                                    "update:error": function ($event) {
                                      return _vm.$set(
                                        _vm.operatorErrors,
                                        "phone",
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.selectedUser.operatorObj.phone,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.selectedUser.operatorObj,
                                        "phone",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "selectedUser.operatorObj.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Adres e-mail")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: { error: _vm.operatorErrors.email },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.operatorErrors,
                                          "email",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.selectedUser.operatorObj.email,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.operatorObj,
                                          "email",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.operatorObj.email",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "col-12 col-lg-3" }, [
                              _c(
                                "div",
                                { staticClass: "mal32" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "form-input__label" },
                                    [_vm._v("Nazwa operatora")]
                                  ),
                                  _c("base-input-text", {
                                    attrs: { error: _vm.operatorErrors.name },
                                    on: {
                                      "update:error": function ($event) {
                                        return _vm.$set(
                                          _vm.operatorErrors,
                                          "name",
                                          $event
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.selectedUser.operatorObj.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedUser.operatorObj,
                                          "name",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedUser.operatorObj.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm.loading
                  ? _c("div", { staticClass: "loader" }, [
                      _c("div", { staticClass: "loader__backdrop" }),
                      _c(
                        "div",
                        { staticClass: "lds-ellipsis lds-ellipsis--center" },
                        [_c("div"), _c("div"), _c("div")]
                      ),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        return _vm.$refs.userModal.closeModal()
                      },
                    },
                  },
                  [_vm._v("Anuluj")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.saveForm },
                  },
                  [_vm._v("Zapisz")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("h1", [_vm._v("Lista użytkowników")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "admin-header__loading-state" }, [
          _vm._v(" Trwa wczytywanie "),
          _c("div", { staticClass: "mal15 lds-ellipsis" }, [
            _c("div"),
            _c("div"),
            _c("div"),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }